import { Component, OnInit,ViewChild } from '@angular/core';
import { UserService } from 'app/shared/services/user.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from 'app/shared/services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogConfig } from '@angular/material/dialog';
import { UsersComponent } from './users.component';
import { CompanyProfileService } from 'app/shared/services/company-profile.service';
import { NbThemeService } from '@nebular/theme';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {

  displayedColumns: string[] = ['empId', 'empName', 'username', 'userType','status','createdBy','action'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  isDark: boolean = false;

  userList : any;  

  constructor(private userService : UserService,
              private dialogService : DialogService,
              private router : Router, 
              private toastr: ToastrService,
              private companyProfileService: CompanyProfileService,
              private themeService: NbThemeService,
             ) { }

  ngOnInit(): void {

    this.getUserList();
    this.companyProfileService.companyName$.subscribe(
      companyName =>{
        this.companyProfileService.selectedCompany = companyName;        
        this.getUserList();
      });

      
      this.themeService.onThemeChange()
      .subscribe(themeName =>{
           this.isDark  = themeName.name ==='dark' ? true : false;
          });
  }

  newButtonClick(){
   this.userService.dataRow = null;
   const dialogConfig = new MatDialogConfig();
   dialogConfig.disableClose = true;
   dialogConfig.autoFocus = true;
   dialogConfig.width = "50%";
   this.dialogService.openDialog(UsersComponent,dialogConfig)
   .afterClosed().subscribe(res => this.getUserList());  
  }

  veiwButtonClick(row){
    this.userService.dataRow = row;  
    const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "50%";
     this.dialogService.openDialog(UsersComponent,dialogConfig)
      .afterClosed().subscribe(res => this.getUserList());

  }


  getUserList(){
    this.userService.getAll()
     .subscribe(
        (data) => {
                  this.userList = data.filter((el)=>{
                    return el.UserName!=='admin';                          
                  });
                  this.dataSource = new  MatTableDataSource (this.userList);  
                  this.dataSource.sort = this.sort;
                  this.dataSource.paginator = this.paginator;  
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }


    deleteButtonClick(id : number){
      this.dialogService.openConfirmDialog('Are you sure you want to delete this record?')
      .afterClosed().subscribe(res =>{
        if(res){
          this.userService.deleteUser(id)
        .subscribe(
          (res) => {
                      this.toastr.success('User was deleted successfully','Success');
                      this.getUserList();
                      console.log(res);     
                    },        
          (err) =>  {
                      this.toastr.error('Failed to delete user','Failure');
                      if(err instanceof HttpErrorResponse){                 
                        if(err.status == 401){
                          this.router.navigate(['/login']);
                        }
                      }
                      console.log(err);
                    }, 
            )
        }
      });            
  }

  applyFilter(){
    this.dataSource.filter =this.searchKey.trim().toLowerCase();

  }
  onSearchClear(){
    this.searchKey = "";
    this.applyFilter();
  }


}//end class
